"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _RangeFilter = _interopRequireDefault(require("../RangeFilter"));
var _utils = require("../../../utils");
var _shared = require("./shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var config = function config(dataSource) {
  var className = {
    Matched: 'matched',
    Unmatched: 'unmatched'
  };
  var getMatchedStatus = function getMatchedStatus(record) {
    return record.isMatched ? 'Matched' : 'Unmatched';
  };
  var columns = [{
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    filters: [{
      text: 'Matched',
      value: true
    }, {
      text: 'Unmatched',
      value: false
    }],
    onFilter: function onFilter(value, record) {
      return record.isMatched === value;
    },
    sorter: (0, _utils.boolSorter)('isMatched'),
    sortDirections: ['ascend', 'descend'],
    render: function render(text, record) {
      var status = getMatchedStatus(record);
      return {
        props: {
          className: "borderedColumn ".concat(className[status], "\n              ").concat(record.highRisk ? 'high-risk' : '')
        },
        children: /*#__PURE__*/_react.default.createElement("span", null, status, record.highRisk && ' (High Risk)')
      };
    },
    width: 140
  }, {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    sorter: (0, _utils.multiStringSorter)(['lastName', 'firstName']),
    render: _shared.renderNameColumn,
    width: 150
  }, {
    title: 'Nickname',
    dataIndex: 'nickName',
    key: 'nickName',
    sorter: (0, _utils.stringSorter)('nickName'),
    width: 150
  }, {
    title: 'Sex',
    dataIndex: 'sex',
    key: 'sex',
    filters: _shared.sexColumnConfig.filters,
    onFilter: (0, _utils.filter)('sex'),
    sorter: (0, _utils.stringSorter)(function (record) {
      return _shared.sexColumnConfig.render[record.sex];
    }),
    width: 100,
    render: (0, _utils.renderColumn)(_shared.sexColumnConfig, 'sex')
  }, {
    title: 'Pronouns',
    dataIndex: 'pronoun',
    key: 'pronoun',
    width: 100
  }, {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    sorter: (0, _utils.stringSorter)('email'),
    width: 200
  }, {
    title: 'Date of Birth',
    dataIndex: 'birthDate',
    key: 'birthDate',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('birthDate'),
    render: function render(id, record) {
      return (0, _utils.formatDate)(record.birthDate, {
        utc: true
      });
    },
    sorter: (0, _utils.timeSorter)('birthDate'),
    width: 150
  }, {
    title: 'State',
    dataIndex: 'state',
    key: 'state',
    sorter: (0, _utils.stringSorter)('state'),
    render: (0, _utils.renderColumn)(_shared.statesColumnConfig, 'state'),
    width: 150
  }, {
    title: 'Appointments attended',
    dataIndex: 'appointmentsAttended',
    key: 'appointmentsAttended',
    sorter: (0, _utils.digitSorter)('appointmentsAttended'),
    width: 100
  }, {
    title: 'Match Date',
    dataIndex: 'matchDate',
    key: 'matchDate',
    // ToDo: filter and sorting should be implemented after BE for match_date is ready
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('matchDate'),
    defaultSortOrder: 'descend',
    sorter: (0, _utils.timeSorter)('matchDate'),
    render: function render(text, record) {
      return (0, _utils.formatDate)(record.matchDate);
    },
    width: 150
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id'
  };
};
var _default = config;
exports.default = _default;